import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";

import DepartmentSelect from "../../common/DepartmentSelect";
import UserSelect from "../../common/UserSelect";
import { formatDate } from "../../../helpers/date";

import ReportFilters from "../ReportFiltersComponent";

const CustomerProjectStatusFilters = ({
  onChange,
  filters,
  onResetClick,
  onFetchClick,
  loading,
  disabled,
  exportDisabled,
  onCSVExport,
  onPDFExport
}) => (
  <ReportFilters
    onFetchClick={onFetchClick}
    onResetClick={onResetClick}
    title={`Customer Project Status as of ${formatDate(
      new Date(),
      "MM/dd/yyyy"
    )}`}
    loading={loading}
    disabled={disabled}
    csvExportAvailable={false}
    pdfExportAvailable
    exportDisabled={exportDisabled}
    onCSVExport={onCSVExport}
    onPDFExport={onPDFExport}
  >
    <Row>
      <Col md={3}>
        <DepartmentSelect
          isMulti
          label="Department"
          placeholder="Select"
          value={filters.department || null}
          onChange={(e) => onChange("department", e || [])}
        />
      </Col>
      <Col md={3}>
        <UserSelect
          label="Project Manager"
          placeholder="Select"
          value={filters.project_manager || null}
          onChange={(e) => onChange("project_manager", e || null)}
        />
      </Col>
    </Row>
  </ReportFilters>
);

CustomerProjectStatusFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  onResetClick: PropTypes.func,
  onFetchClick: PropTypes.func,
  filters: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  exportDisabled: PropTypes.func,
  onCSVExport: PropTypes.func,
  onPDFExport: PropTypes.func
};

function mapStatesToProps(state) {
  return {
    exporting: state.reducers.exporting
  };
}

export default connect(mapStatesToProps, null)(CustomerProjectStatusFilters);
